var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobePlaneBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6905_24170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47667 22 2 17.5233 2 12C2 6.47667 6.47667 2 12 2C17.5233 2 22 6.47667 22 12",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8H21",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56641 15.3337H11.9997",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.445 11.9997C16.445 8.92861 15.6416 5.8575 14.0372 3.1775C13.0961 1.6075 10.905 1.6075 9.96497 3.1775C6.75386 8.53861 6.75386 15.4619 9.96497 20.8231C10.435 21.6075 11.2183 22.0008 12.0016 22.0008",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9367 17.4606L19.8804 22.3033L18.9951 22.8554L17.9329 18.7104L15.5604 20.1902L15.6406 21.943L14.9766 22.3571L14.1928 20.1417L12.5237 18.4785L13.1877 18.0644L14.7432 18.897L17.1157 17.4173L13.8168 14.6673L14.7021 14.1151L19.119 16.1678L21.5301 14.664C21.7062 14.5542 21.9181 14.5169 22.1193 14.5605C22.3205 14.6041 22.4944 14.7249 22.6028 14.8963C22.7113 15.0678 22.7453 15.2758 22.6974 15.4747C22.6496 15.6736 22.5238 15.847 22.3477 15.9569L19.9367 17.4606Z",
    fill: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6905_24170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobePlaneBlack);
export default __webpack_public_path__ + "static/media/globe_plane_black.984b8254e4f2a16a25b05dce6ec61077.svg";
export { ForwardRef as ReactComponent };